import React from 'react';
import debounce from 'debounce';

import { AutoComplete } from 'antd';

import { _getSearchBrands } from '../../services';

class BrandAutocomplete extends React.Component{

	render(){

		const { dataSource } = this.state;

		return (
			<AutoComplete
				dataSource={dataSource}
				style={{ width: 200 }}
				onSelect={this.onSelect}
				onChange={this.onChange}
				placeholder="Search Brand"
			/>

		)
	}

	state = {
		dataSource: []
	}

	constructor(props){
		super(props);

		this.handleSearch = debounce(this.handleSearch, 200);
	}

	onChange = ( searchTerm ) => {
		this.handleSearch( searchTerm );
	}

	onSelect = (e) => {
		this.props.onSelect(e)
	}

	handleSearch = ( value ) => {
		_getSearchBrands( value )
			.then( res => {
				this.setState({
					dataSource: res.data.brands.map( b => b.name )
				})
			})
		
	}

}

export default BrandAutocomplete;


// WEBPACK FOOTER //
// ./src/components/brands/brand-autocomplete.js